/*
 *
 * SubmitFinalPage constants
 *
 */

export const DEFAULT_ACTION = "app/SubmitFinalPage/DEFAULT_ACTION";
export const DATA= "app/SubmitFinalPage/DATA";